import { useEffect, useRef, useState } from "react";
import { Checkbox, Icon, Popup } from "semantic-ui-react";

const CSVSummary = (props) => {
  const { finalSummary, t } = props;
  const reportRef = useRef();

  const [containerInitialHeight, setContainerInitialHeight] = useState("");
  const [containerScrollHeight, setContainerScrollHeight] = useState("");
  const [containerMaxHeight, setContainerMaxHeight] = useState("");
  const [incidentsMarkedAsDone, setIncidentsMarkedAsDone] = useState(0);
  const [incidentsLayerView, setIncidentsLayerView] = useState("minimize");

  useEffect(() => {
    reportRef.current.offsetParent.offsetParent.style.width = "98%";
    const headerElement = reportRef.current.ownerDocument.getElementsByClassName("page-head");
    // Get incidents-container scroll height.
    setContainerScrollHeight(window.innerHeight - 100);
    // Calculate the height of the header element, to set the fixed initial max-height of the container, for initial view and minimized view.
    const IncidentsMinimizeHeight =
      parseInt(window.getComputedStyle(headerElement[0])["margin-bottom"].split("p")[0]) +
      headerElement[0].getBoundingClientRect().height;
    setContainerMaxHeight(IncidentsMinimizeHeight);
    // Container initial height
    setContainerInitialHeight(IncidentsMinimizeHeight);
  }, []);

  const handleCheckboxChange = (e) => {
    !e.target.previousSibling.checked
      ? setIncidentsMarkedAsDone(incidentsMarkedAsDone + 1)
      : setIncidentsMarkedAsDone(incidentsMarkedAsDone - 1);
  };

  const calculateContainerMaxHeight = () => {
    return containerScrollHeight > 260 ? containerScrollHeight : 260;
  };

  const handleResize = (newSize) => {
    incidentsLayerView !== newSize && setIncidentsLayerView(newSize);
    newSize === "showMore"
      ? setContainerMaxHeight(260)
      : newSize === "showAll"
      ? setContainerMaxHeight(calculateContainerMaxHeight())
      : setContainerMaxHeight(containerInitialHeight);
  };

  return (
    <div ref={reportRef}>
      <div style={{ display: "flex", gap: "1rem" }}>
        <h4>{t("CSV_campaign_creation_summary")}</h4>
        <strong>
          {t("CSV_campaign_creation_incidents", { numberOfIncidents: finalSummary.length })}
        </strong>
        <strong>
          {t("CSV_campaign_creation_incidents_done", {
            incidentsMarkedAsDone: `${incidentsMarkedAsDone} \\ ${finalSummary.length}`,
          })}
        </strong>
        <div className="window-controls" style={{ marginLeft: "auto" }}>
          <Popup
            content={t("CSV_campaign_creation_summary_minimize")}
            trigger={
              <Icon name="window minimize outline" onClick={() => handleResize("minimize")} />
            }
          />
          <Popup
            content={t("CSV_campaign_creation_summary_show_more")}
            trigger={
              <Icon name="arrows alternate vertical" onClick={() => handleResize("showMore")} />
            }
          />
          <Popup
            content={t("CSV_campaign_creation_summary_full_screen")}
            trigger={<Icon name="expand" onClick={() => handleResize("showAll")} />}
          />
        </div>
      </div>
      <div
        id="incidents-container"
        style={{
          //container max-height set to the total height of the "page-head" component minus "usual" browser default font size for the gap
          maxHeight: `${containerMaxHeight - 16}px`,
          overflowY: "auto",
          overflowX: "hidden",
          fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
          fontSize: "1em",
        }}
      >
        {finalSummary.map((report, line) => (
          <div
            key={line}
            className={report.errorType}
            style={{
              display: "flex",
              gap: ".5rem",
              margin: "0 0 .3rem .15rem",
              lineHeight: "1.7rem",
            }}
          >
            <Checkbox toggle onChange={(e) => handleCheckboxChange(e)} />
            <Icon
              name={report.errorType === "warning" ? "warning" : "x"}
              color={report.errorType === "warning" ? "yellow" : "red"}
            />
            <p>{`${report.campaignName}: ${report.errorText}`}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CSVSummary;
